import React from 'react';
import { BadgeCheck } from 'lucide-react';

/** Blue check shown next to Lumera's official account name. */
const OfficialBadge = ({ className = 'w-4 h-4' }) => (
  <BadgeCheck className={`${className} text-sky-500 fill-sky-100 shrink-0`} data-testid="official-badge" aria-label="Official" />
);

export default OfficialBadge;
